import { PureComponent } from 'react';

import { css } from '@emotion/react';
import { dashboard } from 'types';
import { filter, isEmpty, map, sortBy, uniqBy } from 'es-toolkit/compat';
import TagTypes from 'constants/TagTypes';
import icons from 'components/icons/svgr/tag-icons';

interface Props {
  isPartyCard?: boolean;
  tags: dashboard.Tag[];
  type: string;
}

const COLOR_VISIT_PRIMARY = 'var(--lilac-base)';
const COLOR_GUEST_PRIMARY = 'var(--blaze-base)';

class TagIconsList extends PureComponent<Props> {
  render() {
    const { tags, type, isPartyCard } = this.props;
    const onlyUniqueIcons = uniqBy(
      filter(tags, (tag) => !isEmpty(tag.icon)),
      'icon'
    );
    const sortedTags = sortBy(onlyUniqueIcons, 'ordering');

    const iconCss = css`
      cursor: inherit;
      ${type === TagTypes.VISIT && `color: ${COLOR_VISIT_PRIMARY};`}
      ${type === TagTypes.GUEST && `color: ${COLOR_GUEST_PRIMARY};`}
      ${isPartyCard &&
      `
        margin-right: 4px;
        vertical-align: middle;
      `}
    `;

    return map(sortedTags, (tag) => {
      const Icon = icons[tag.icon];
      return Icon ? (
        <Icon
          size={isPartyCard ? 100 : undefined}
          css={iconCss}
          key={tag.icon}
          data-for="tooltip"
          data-tip={tag.text}
        />
      ) : null;
    });
  }
}

export default TagIconsList;
